// export const HOST = "http://14.248.94.155:3000";
// export const HOST = "http://localhost:5000";
// export const HOST = "https://api.bandodulichdaknong.vn";
// export const HOST = "http://localhost:46928";
export const HOST = "https://api.bandodulichdaknong.vn";
export const API = HOST + "/api";
export const API_LOGIN = API + "/auth/login";
export const PUBLIC = "/public";
